import "./style/index.css?global";
import "../time-picker/style/index.css?global";
import "../input/style/index.css?global";
import momentGenerateConfig from "rc-picker/es/generate/moment";
import generatePicker from "./generate-picker";
export default generatePicker(momentGenerateConfig);